'use client';

import { Feed } from "@/components/feed";
import { ChatHeader } from "@/components/chat-header";
import { OnboardingPlatformTour } from "@/components/onboarding-platform-tour";
import { CommunityBuddyTour } from "@/components/buddy/CommunityBuddyTour";
import { PLATFORM_TOUR_STEP_COMMUNITY } from "@/lib/platform-tour-constants";

export default function CommunityPage() {
  return (
    <div className="min-h-screen bg-[#09090b]">
      {/* Community leg of the cross-page onboarding chain. Activates
          when the URL carries ?onboarding_community=1 (set by the
          home tour when the user clicks Browse more on the Community
          Use Cases pill). */}
      <CommunityBuddyTour />
      {/* Cross-page platform tour — fires when URL carries
          ?ptour=community. Kicks off the 2-beat /community scene,
          then advances to /blog?ptour=trades. */}
      <OnboardingPlatformTour expectedStep={PLATFORM_TOUR_STEP_COMMUNITY} />
      <ChatHeader
        chatId=""
        selectedVisibilityType="public"
        isReadonly={false}
        section="chat"
        title="Community"
      />
      <div className="w-full max-w-6xl mx-auto px-4 pt-4">
        <div data-tour="community-hero" className="mb-2">
          <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold text-white tracking-tight">
            Community
          </h1>
          <p className="mt-1.5 sm:mt-2 text-sm sm:text-[15px] text-zinc-400 max-w-2xl leading-relaxed">
            Explore top research sessions shared by the Xynth community.
          </p>
        </div>
      </div>
      {/* data-tour wrapper so the tour can spotlight the whole feed
          grid. Kept as a bare div (no layout impact) to avoid fighting
          the Feed component's own container styles. */}
      <div data-tour="community-feed">
        <Feed limit={12} variant="full" stickyHeader={true} showCuratedStrategies={false} />
      </div>
    </div>
  );
}
